<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ "COMMON.CART" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-menu-button class="text-primary" mode="md" />
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        color="primary"
        (click)="shareCartHandler()"
        [disabled]="!cartStore.items().length || isSharing"
      >
        <ion-icon slot="icon-only" name="share-social-outline"></ion-icon>
      </ion-button>
      <ion-button fill="clear" color="danger" (click)="clear()">{{ "CART.CLEAR" | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  <div class="flex h-full justify-center">
    <div class="flex w-full flex-col md:max-w-[650px] h-full">
      @if (cartStore.items().length) {
        <ion-card class="mt-5 border-none flex flex-col max-h-full min-h-0">
          <div class="overflow-y-auto overscroll-contain" style="-webkit-overflow-scrolling: touch">
            <ion-list class="bg-transparent !m-0 !p-0">
              @for (item of cartStore.items(); track item.product.id + "-" + (item.variation?.id || "")) {
                <div
                  class="flex items-center px-2 py-4 hover:bg-light cursor-pointer will-change-auto"
                  [routerLink]="['/vendors', item.product.vendorId, 'products', item.product.id]"
                  routerDirection="forward"
                  style="contain: layout style paint"
                >
                  <mtjr-img
                    [src]="item.product.images?.[0] || item.variation?.image"
                    imgClass="w-24 aspect-square rounded-xl p-[0.2px] border border-solid border-medium/30 me-2 object-cover"
                    alt="thumbnail"
                    loading="lazy"
                    decoding="async"
                  />
                  <div class="ms-2 flex flex-1 flex-col">
                    <div class="flex flex-wrap justify-end gap-2 pe-2">
                      <ion-text class="me-auto ms-3 pe-4 font-bold">{{ item.product.name }}</ion-text>

                      @for (attr of item.variation?.attributes; track $index) {
                        @if (attr.type !== "color") {
                          <div
                            class="border-primary text-primary bg-primary/10 min-w-6 rounded-full px-2 py-1 text-center"
                          >
                            <ion-label>
                              {{ "ATTRIBUTE." + attr.typeLabel.toUpperCase() | translate }} - {{ attr.label }}
                            </ion-label>
                          </div>
                        } @else {
                          <div
                            class="border-medium !m-0 flex size-6 items-center justify-center rounded-full border-2 border-solid !p-0 text-white"
                            [ngStyle]="{
                              'background-color': attr.key,
                            }"
                          ></div>
                        }
                      }
                    </div>
                    <ion-text class="ms-3 mt-1">
                      <span class="text-primary text-sm font-bold">
                        {{
                          (item.variation?.price || item.product.price || 0) -
                            (item.product.discount || item.variation?.discount || 0) | vxCurrency
                        }}
                      </span>
                      @if (item.product.discount || item.variation?.discount) {
                        <span class="text-medium text-md ms-3 line-through">
                          {{ item.variation?.discount || item.product.discount || 0 | vxCurrency }}
                        </span>
                      }
                    </ion-text>
                    <div class="flex flex-1 items-center">
                      <ion-button
                        fill="clear"
                        shape="round"
                        (click)="cartStore.decreaseItemQuantity($index); $event.stopPropagation()"
                      >
                        <ion-icon color="medium" slot="icon-only" name="remove-circle-outline"></ion-icon>
                      </ion-button>
                      <ion-text class="font-bold">{{ item.quantity.toString().padStart(2, "0") }}</ion-text>
                      <ion-button
                        fill="clear"
                        shape="round"
                        (click)="cartStore.increaseItemQuantity($index); $event.stopPropagation()"
                      >
                        <ion-icon color="medium" slot="icon-only" name="add-circle-outline"></ion-icon>
                      </ion-button>
                      <div class="flex-grow"></div>
                      <ion-button
                        fill="clear"
                        size="small"
                        color="danger"
                        (click)="cartStore.removeItem($index); $event.stopPropagation()"
                      >
                        {{ "COMMON.REMOVE" | translate }}
                      </ion-button>
                    </div>
                  </div>
                </div>
                @if ($index !== cartStore.items().length - 1) {
                  <div class="bg-light mx-8 h-[1px]"></div>
                }
              }
            </ion-list>
          </div>
        </ion-card>
      } @else {
        <div class="flex h-full w-full flex-col items-center justify-center">
          <mtjr-dynamic-img
            src="/assets/no_orders.svg"
            darkSrc="/assets/no_orders_dark.svg"
            class="size-[220px] opacity-80 dark:opacity-70"
          />
          <p class="text-medium/70 mt-2 text-center">{{ "CART.CART_IS_EMPTY" | translate }}</p>
        </div>
      }
      @if (cartStore.items().length > 0) {
        <ion-button
          expand="block"
          color="primary"
          class="mx-4 mb-4 mt-4 h-10 capitalize flex-shrink-0"
          [disabled]="!cartStore.items().length"
          routerLink="checkout"
        >
          {{ "CART.PROCEED_TO_CHECKOUT" | translate }}
        </ion-button>
      }
    </div>
  </div>
</ion-content>
